// **..support-width-accordion js start..**
$(document).ready(function () {

    // **..support-width-accordion js end..**
    $('.support-with-accordion-item-title').on('click', function () {
      $(this).next().slideToggle();
      $(this).parent().toggleClass('active'); 
    });
  
    // printer tab js--
    $('.tabs-nav-item:first-child').addClass('active');
    $('.tabs-content-items').hide();
    $('.tabs-content-items:first').show();
  
    $('.tabs-nav-item').click(function () {
      $('.tabs-nav-item').removeClass('active');
      $(this).addClass('active');
      $('.tabs-content-items').hide();
  
      var activeTab = $(this).find('a').attr('href');
      $(activeTab).fadeIn(); 
      return false; 
    });
  

    // profit calculator ---
    $("#product_range").on('change', function(){
      var product = $(this).val();
      var cost = $('#cost_range').val();
      var cost_product = $('.cost_product').val();

      var s = (product * cost).toFixed(1);
      var mp = ((cost - cost_product) * product).toFixed(1);
      var yp = (mp * 12).toFixed(1);
      var p = (product * 0.17).toFixed(1);

      profitCalculator(s, mp, yp, p)
    });

    $("#cost_range").on('change', function(){
      var cost = $(this).val();
      var product = $('#product_range').val();
      var cost_product = $('.cost_product').val();

      var s = (product * cost).toFixed(1);
      var mp = ((cost - cost_product) * product).toFixed(1);
      var yp = (mp * 12).toFixed(1);
      var p = (product * 0.17).toFixed(1);

      profitCalculator(s, mp, yp, p)
    });
  })

  function profitCalculator(s, mp, yp, p) {
    $('.monthly_sale').text(s);
    $('.monthly_profit').text(mp);
    $('.yearly_profit').text(yp);
    $('.hour_production').text(p);
  }
  
  // printer swiper slider js--
  var swiper = new Swiper(".printer-swiper-slider", {
    spaceBetween: 30,
    slidesPerView: 3,
    grabCursor: true,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 320px
      1: {
        slidesPerView: 1,
      },
      // when window width is >= 480px
      576: {
        slidesPerView: 2,
      },
      // when window width is >= 992px
      992: {
        slidesPerView: 3,
      }
    }
  });

  // profit calculator 

  document.addEventListener("DOMContentLoaded", () => {
    const range = document.getElementById('product_range');
    const tooltip = document.getElementById('product_tooltip');
  
    if (range && tooltip) {
      const setValue = () => {
        const newValue = Number((range.value - range.min) * 100 / (range.max - range.min));
        const newPosition = 16 - (newValue * 0.32);
        tooltip.innerHTML = `<span>${range.value}</span>`;
        tooltip.style.left = `calc(${newValue}% + (${newPosition}px))`;
        document.documentElement.style.setProperty("--range-progress", `calc(${newValue}% + (${newPosition}px))`);
      };
      
      setValue(); // Initialize value on DOMContentLoaded
      range.addEventListener('input', setValue);
    } else {
      console.warn("Elements with IDs 'product_range' or 'product_tooltip' are missing.");
    }
  
    const range2 = document.getElementById('cost_range');
    const tooltip2 = document.getElementById('cost_tooltip');
  
    if (range2 && tooltip2) {
      const setValue2 = () => {
        const newValue2 = Number((range2.value - range2.min) * 100 / (range2.max - range2.min));
        const newPosition2 = 16 - (newValue2 * 0.32);
        tooltip2.innerHTML = `<span>${range2.value}</span>`;
        tooltip2.style.left = `calc(${newValue2}% + (${newPosition2}px))`;
        document.documentElement.style.setProperty("--range-progress2", `calc(${newValue2}% + (${newPosition2}px))`);
      };
      
      setValue2(); // Initialize value on DOMContentLoaded
      range2.addEventListener('input', setValue2);
    } else {
      console.warn("Elements with IDs 'cost_range' or 'cost_tooltip' are missing.");
    }
  });
